/* ============================================================
 * Elite Games — Marquee que ademas se arrastra con el dedo.
 *
 * La animacion CSS (translateX) no se puede tocar con el dedo:
 * el navegador la controla entera. Asi que aca la cambiamos por
 * scroll nativo del contenedor:
 *   · el dedo arrastra de verdad, con la inercia del sistema
 *   · entre gestos seguimos avanzando solos, al mismo ritmo
 *   · al llegar al final saltamos una tanda hacia atras, y como
 *     el contenido esta duplicado el empalme no se ve
 *
 * Si este archivo no carga, la animacion CSS sigue funcionando
 * igual que antes: la clase que la apaga la pone este script.
 * ============================================================ */
/* Tres secciones piden este archivo: se ejecuta una sola vez. */
window.EGMarqueeDrag = window.EGMarqueeDrag || (function () {
  'use strict';

  var reduce = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var now = function () {
    return window.performance && performance.now ? performance.now() : Date.now();
  };

  function init(vp, track, opts) {
    if (!vp || !track || vp.__egmq) return null;
    opts = opts || {};

    /* Nada que desplazar: dejamos el CSS como esta. */
    if (track.scrollWidth <= vp.clientWidth + 2) return null;

    var dir      = opts.direction === 'rtl' ? -1 : 1;
    var duration = Math.max(1, opts.duration || 40);   /* segundos por vuelta, igual que el CSS */
    var idleMs   = opts.idle == null ? 900 : opts.idle;

    /* El contenido viene duplicado exactamente una vez. */
    var unit = track.children.length >> 1;
    if (!unit) return null;

    var period = 0, speed = 0, max = 0;
    var pos = 0, last = 0, hold = 0, prev = 0, raf = 0;
    var hovering = false;

    /* Ancho exacto de UNA tanda: la distancia entre el item 0 y su copia.
       Es mas preciso que scrollWidth/2, que arrastra el padding del track. */
    function measure() {
      var ch = track.children;
      period = (ch[unit] && ch[0]) ? (ch[unit].offsetLeft - ch[0].offsetLeft) : 0;

      /* Para que el salto de una tanda sea invisible necesitamos poder
         desplazarnos al menos una tanda entera. Con pocos items no alcanza:
         clonamos tandas hasta que si alcance. */
      var guard = 0;
      while (period > 0 && (track.scrollWidth - vp.clientWidth) < period + 40 && guard++ < 8) {
        for (var i = 0; i < unit; i++) {
          var c = track.children[i].cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          track.appendChild(c);
        }
      }

      /* Con muchos items conviene medir la vuelta en segundos (asi lo hacia
         el CSS). Con pocos, esa cuenta da un arrastre lentisimo, y ahi es
         mejor fijar los pixeles por segundo a mano. */
      speed = opts.pxPerSec ? opts.pxPerSec : (period / duration);
      max   = vp.scrollWidth - vp.clientWidth;
      if (period < 2 || max < 2) period = 0;
    }

    function touched() { hold = now() + idleMs; }

    function step(ts) {
      if (!vp.isConnected) { cancelAnimationFrame(raf); vp.__egmq = false; return; }
      raf = requestAnimationFrame(step);

      var dt = prev ? Math.min(0.05, (ts - prev) / 1000) : 0;
      prev = ts;
      if (!period) return;

      var free = !reduce && ts >= hold && !hovering;

      if (!free) {
        /* Mientras el dedo manda no escribimos nada: cualquier escritura
           mataria la inercia del navegador. Lo unico que corregimos es el
           muro de los extremos, para que la tira nunca se sienta topada. */
        pos = vp.scrollLeft;
        if (pos > max - 4) { pos -= period; vp.scrollLeft = pos; }
        else if (hold && pos < 4) { pos += period; vp.scrollLeft = pos; }
        last = vp.scrollLeft;
        return;
      }

      /* Si el usuario movio la tira, retomamos desde donde la dejo. */
      if (Math.abs(vp.scrollLeft - last) > 1.5) pos = vp.scrollLeft;

      pos += dir * speed * dt;
      if (pos >= period) pos -= period;
      else if (pos < 0) pos += period;

      vp.scrollLeft = pos;
      last = vp.scrollLeft;
    }

    /* ── Gestos ─────────────────────────────────────────────── */
    vp.addEventListener('touchstart', touched, { passive: true });
    vp.addEventListener('wheel', touched, { passive: true });
    vp.addEventListener('keydown', touched);
    vp.addEventListener('scroll', function () {
      if (Math.abs(vp.scrollLeft - last) > 1.5) touched();
    }, { passive: true });

    if (opts.pauseHover) {
      vp.addEventListener('mouseenter', function () { hovering = true; });
      vp.addEventListener('mouseleave', function () { hovering = false; });
    }

    /* Con mouse no hay scroll por arrastre, asi que lo hacemos a mano.
       El dedo NO pasa por aca: ahi manda el scroll nativo. */
    var down = false, startX = 0, startL = 0, moved = false;

    vp.addEventListener('pointerdown', function (e) {
      touched();
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (e.button) return;
      down = true; moved = false;
      startX = e.clientX; startL = vp.scrollLeft;
      vp.classList.add('eg-mq-grab');
    });

    function move(e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      vp.scrollLeft = startL - dx;
      last = vp.scrollLeft;
      touched();
      e.preventDefault();
    }
    function up() {
      if (!down) return;
      down = false;
      vp.classList.remove('eg-mq-grab');
      touched();
    }
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);

    /* Tras arrastrar, el click no debe abrir el enlace de la tarjeta. */
    vp.addEventListener('click', function (e) {
      if (!moved) return;
      moved = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    /* ── Arranque ───────────────────────────────────────────── */
    vp.__egmq = true;
    measure();
    if (!period) { vp.__egmq = false; return null; }

    if (opts.flag) opts.flag();          /* apaga la animacion CSS */
    vp.scrollLeft = 0; pos = 0; last = 0;

    var rm;
    if (window.ResizeObserver) {
      rm = new ResizeObserver(function () { measure(); });
      rm.observe(vp);
    } else {
      window.addEventListener('resize', measure);
    }

    raf = requestAnimationFrame(step);
    return { measure: measure };
  }

  return { init: init };
})();
